import API from './config'

function getConfig() {
    return {
        headers: {
            'x-access-token': localStorage.getItem('token'),
        }
    }
}

async function doRequest(request) {
    try {
        const response = await request();
        return {
            success: true,
            body: response.data
        };
    } catch (error) {
        return {
            success: false,
            body: error.response ? error.response.data : error
        };
    }
}

export const ClientFundRatesAPI = {

    /**
     * Ajustes manuais de taxas dos fundos do cliente (uma linha por fundo ajustado)
     * @param {number} clientId
     */
    async listByClient(clientId) {
        return doRequest(() => API.get(`/client-fund-rates/client/${clientId}`, getConfig()));
    },

    /**
     * Grava os ajustes do fundo; taxa null = usar a ComDinheiro. Todas null removem o ajuste.
     * @param {number} clientId
     * @param {number} fundId
     * @param {{max_administration_tax, administration_tax, management_tax, distribution_tax, custody_tax, performance_tax}} data
     */
    async upsert(clientId, fundId, data) {
        return doRequest(() => API.put(`/client-fund-rates/client/${clientId}/fund/${fundId}`, data, getConfig()));
    },

    /**
     * Remove todos os ajustes manuais do fundo para o cliente
     */
    async remove(clientId, fundId) {
        return doRequest(() => API.delete(`/client-fund-rates/client/${clientId}/fund/${fundId}`, getConfig()));
    },
};
